import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import { ThreeDots } from "react-loader-spinner";
import { Dialog } from "primereact/dialog";

import CopyToClipboard from "../../../common/CopyToClipboard";

import "../index.css"

import NewBuyerPOModalData from "./NewBuyerPOModalData";

import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import { getCompanyShortName, getDateString, getFullName, getReqShortDetails } from "../../../utils";
import Tooltip from "../../../helpers/Tooltip";
import PMUserName from "../../../common/PMUserName";


const BuyerPoModalData = (props) => {
    const { selectedReq, buyerQuotes, setVisibleBuyerpo, visibleBuyerpo, materialDetails, approvalInstances } = props

    const [isLoading, setIsLoading] = useState(true)
    const [relatedBuyerQuotes, setRelatedBuyerQuotes] = useState([])

    const dispatch = useDispatch()
    const buyerPOData = useSelector(state => state.requirements.buyerPOData)
    const orderTypes = useSelector(state => state.common.orderTypes)

    useEffect(() => {
        setIsLoading(false)
        let activeBuyerQuotesData = buyerQuotes?.filter(eachBuyerQuote => eachBuyerQuote?.buyerReqId === selectedReq?.buyerReqId && [1, 6].includes(eachBuyerQuote?.statusId))
        
        activeBuyerQuotesData = activeBuyerQuotesData?.map(eachBuyerQuote => {
            return { ...eachBuyerQuote }
        })

        activeBuyerQuotesData = _.orderBy(activeBuyerQuotesData, ['createdAt'], ['desc'])

        setRelatedBuyerQuotes(activeBuyerQuotesData)
    }, [selectedReq])

    const handleOnHideDialog = () => {
        setVisibleBuyerpo(false)
    }

    const renderHeader = () => {
        return (
            <div className="flex flex-row justify-content-between">
                <p>BUYER PURCHASE ORDER</p>
            </div>
        )
    }

    let buyerName = getFullName(selectedReq["buyer.firstName"], selectedReq["buyer.lastName"])  

    const renderRequirementDetails = (buyerReq) => {
        const { shortDenotation, fullDenotation } = getReqShortDetails(buyerReq, orderTypes)
        const kamName = getFullName(buyerReq["kam.firstName"], buyerReq["kam.lastName"])
        const companyDisplayName = getCompanyShortName(buyerReq["company.companyName"])
        const reqCreatedAt = getDateString(buyerReq.createdAt)

        return (
            <p className="m-0">
                <span style={{fontWeight:"bold"}}>Req No: </span><span className="ml-1">{buyerReq["docNo"]} <CopyToClipboard text={buyerReq["docNo"]} /></span>
                <span className={`requirement-short-details`}> {shortDenotation}</span>
                <span className=""> by <PMUserName userName={kamName} userId={buyerReq.createdBy} /> ({buyerReq["pmCompanyBranch.branchName"]})</span> 
                <span className=""> on {reqCreatedAt}</span>
                <span className=""> for </span> <span style={{fontWeight:"bold"}}>{companyDisplayName} </span> <span className="ml-1"> - {buyerReq["buyerCompanyBranch.branchName"]} - {buyerName}</span>  

                <Tooltip target={`.requirement-short-details`} position='bottom'>
                    <span>{fullDenotation}</span>
                </Tooltip>
            </p>
        )
    }

    return (
        <Dialog header={renderHeader} headerClassName="pb-0" className="buyerpo-dialog" visible={visibleBuyerpo} style={{ width: '95vw', height: '80vh' }} onHide={handleOnHideDialog}>
            <div className="buyerpo-modal">
                {selectedReq && renderRequirementDetails(selectedReq)}
                {
                    isLoading ?
                        (
                            <div className="flex justify-content-center h-full">
                                <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={isLoading} />
                            </div>
                        ) : (
                            relatedBuyerQuotes.length > 0 ?
                                relatedBuyerQuotes.map((eachBuyerQuote, index) => {
                                    const relatedBuyerPOs = buyerPOData.buyerPOs.filter(eachBuyerPO => eachBuyerPO.buyerQuoteId === eachBuyerQuote.buyerQuoteId)
                                    return (
                                        relatedBuyerPOs?.map(eachBuyerPO => {
                                            const relatedApprovalInstances = approvalInstances.filter(eachApprovalInstance => eachApprovalInstance.docNo === eachBuyerPO.docNo)
                                            const relatedBuyerPOItems = buyerPOData.buyerPOItems?.filter(eachBuyerPOItem => eachBuyerPOItem?.buyerPOId === eachBuyerPO?.buyerPOId)
                                            const buyerReqItemIds = relatedBuyerPOItems.map(eachBuyerPOItem => eachBuyerPOItem.buyerReqItemId)
                                            const relatedMaterialDetails = materialDetails.filter(eachMaterialDetail => buyerReqItemIds.includes(eachMaterialDetail.buyerReqItemId))
                                            return (
                                                <NewBuyerPOModalData 
                                                    buyerPO={eachBuyerPO}
                                                    buyerPOItems={relatedBuyerPOItems}
                                                    buyerPOId={eachBuyerPO.buyerPOId} 
                                                    buyerQuotes={[eachBuyerQuote]}
                                                    selectedReq={selectedReq}
                                                    approvalInstances={relatedApprovalInstances}
                                                    materialDetails={relatedMaterialDetails}
                                                />
                                            )
                                        })
                                    )}
                                ) :
                                <div className="flex justify-content-center">
                                    <p className="font-bold">No Buyer Purchase Orders found for the selected requirement.</p>
                                </div>
                        )
                }
            </div>
        </Dialog>
    )
}

export default BuyerPoModalData;
